module.exports = __webpack_public_path__ + "static/media/oppermann-associates.d6134c29.png";